var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { Box, Dialog, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, Stack, Typography, } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useWebgate } from "@xvia/webgate-connect";
import Loading from "../../../components/Loading";
import FormRenderer from "./FormRenderer";
import { sendFormResponseToExternalAPI } from "../../../apis";
import { SurveyElementTypeEnum, } from "../../../types/forms";
import AlertContainer from "../../../components/AlertContainer";
import { flattenPageElements, removePageWithoutElements, } from "../../../utils/forms-functions";
import { getElementValueKey } from "../../../utils/helpers";
import { CheckCircle, Close, ErrorOutline } from "@mui/icons-material";
import { useAccessTokenRef } from "../hooks/useAccessTokenRef";
var AUTH_READY_FALLBACK_MS = 3000;
var SUBMIT_ERROR_FEEDBACK = {
    expired: {
        title: "Sessão expirada!",
        message: "Sua sessão expirou. O que você preencheu continua nesta página — não atualize nem feche a aba. Tente enviar novamente em alguns instantes; se continuar falhando, será preciso entrar de novo e preencher novamente.",
    },
    forbidden: {
        title: "Sem permissão para responder",
        message: "Você não tem permissão para responder este formulário.",
    },
    unstable: {
        title: "Erro ao enviar resposta!",
        message: "Não foi possível enviar sua solicitação neste momento devido a uma instabilidade no sistema. As informações preenchidas foram mantidas na página. Por favor, tente novamente em alguns instantes.",
    },
};
var getSubmitErrorFeedback = function (status) {
    if (status === 401)
        return SUBMIT_ERROR_FEEDBACK.expired;
    if (status === 403)
        return SUBMIT_ERROR_FEEDBACK.forbidden;
    return SUBMIT_ERROR_FEEDBACK.unstable;
};
var RenderContainer = function (_a) {
    var _b, _c;
    var config = _a.config;
    var _d = useWebgate(), userInfo = _d.userInfo, portalConnect = _d.portalConnect, initialized = _d.initialized;
    var _e = useAccessTokenRef(), accessTokenRef = _e.accessTokenRef, hasAccessToken = _e.hasAccessToken;
    var _f = config.requireServiceSlug, requireServiceSlug = _f === void 0 ? false : _f, _g = config.defaultAuthRequired, defaultAuthRequired = _g === void 0 ? false : _g;
    var logPrefix = (_b = config.logPrefix) !== null && _b !== void 0 ? _b : "RC";
    var _h = useState({}), formData = _h[0], setFormData = _h[1];
    var _j = useState({
        id: "",
        title: "",
        callbackURL: null,
        callbackIncludeUserAuth: false,
        published: false,
    }), formAttributes = _j[0], setFormAttributes = _j[1];
    var _k = useState(defaultAuthRequired), formAuthRequired = _k[0], setFormAuthRequired = _k[1];
    var _l = useState(true), isLoading = _l[0], setIsLoading = _l[1];
    var _m = useState(false), formNotFoundError = _m[0], setFormNotFoundError = _m[1];
    var redirectTimeoutRef = useRef(null);
    var loadedSlugRef = useRef(null);
    var _o = useState({
        open: false,
        title: "",
        message: "",
        variant: "success",
    }), modalData = _o[0], setModalData = _o[1];
    var searchParams = useSearchParams()[0];
    var slug = useParams().slug;
    var serviceSlug = (_c = searchParams.get("serviceSlug")) === null || _c === void 0 ? void 0 : _c.trim();
    var isPreview = searchParams.get("isPreview") === "true";
    var missingServiceSlug = requireServiceSlug && !serviceSlug && !isPreview;
    var mustAuthenticate = formAuthRequired && !hasAccessToken;
    var redirectToLogin = useCallback(function () {
        portalConnect === null || portalConnect === void 0 ? void 0 : portalConnect.login();
    }, [portalConnect]);
    var redirectToPortal = useCallback(function () {
        window.location.href = process.env.PORTAL_URL || "";
    }, []);
    var clearRedirectTimeout = useCallback(function () {
        if (redirectTimeoutRef.current !== null) {
            clearTimeout(redirectTimeoutRef.current);
            redirectTimeoutRef.current = null;
        }
    }, []);
    useEffect(function () {
        var cancelled = false;
        var settled = false;
        if (missingServiceSlug) {
            setIsLoading(false);
            return function () {
                cancelled = true;
            };
        }
        if (loadedSlugRef.current === slug) {
            return function () {
                cancelled = true;
            };
        }
        loadedSlugRef.current = slug;
        setIsLoading(true);
        config
            .fetchForm(slug, accessTokenRef.current)
            .then(function (response) {
            var _a, _b;
            if (cancelled)
                return;
            var data = response.data;
            setFormAuthRequired((_a = data === null || data === void 0 ? void 0 : data.authRequired) !== null && _a !== void 0 ? _a : defaultAuthRequired);
            var formattedData = removePageWithoutElements(data.schema);
            setFormData(formattedData);
            setFormAttributes({
                id: data.id,
                title: data.title,
                callbackURL: data.callbackURL || null,
                callbackIncludeUserAuth: (_b = data.callbackIncludeUserAuth) !== null && _b !== void 0 ? _b : false,
                published: data.published,
            });
        })
            .catch(function (error) {
            var _a;
            if (cancelled)
                return;
            if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 404) {
                setFormNotFoundError(true);
            }
            else {
                loadedSlugRef.current = null;
                console.error("".concat(logPrefix, "135 - Erro ao carregar formul\u00E1rio:"), error);
            }
        })
            .finally(function () {
            settled = true;
            if (cancelled)
                return;
            setIsLoading(false);
        });
        return function () {
            cancelled = true;
            if (!settled) {
                loadedSlugRef.current = null;
            }
        };
    }, [
        missingServiceSlug,
        slug,
        hasAccessToken,
        accessTokenRef,
        isPreview,
        config,
        logPrefix,
        defaultAuthRequired,
    ]);
    useEffect(function () {
        if (isPreview || isLoading || missingServiceSlug || !mustAuthenticate) {
            return;
        }
        if (initialized) {
            redirectToLogin();
            return;
        }
        redirectTimeoutRef.current = setTimeout(function () {
            redirectTimeoutRef.current = null;
            redirectToLogin();
        }, AUTH_READY_FALLBACK_MS);
        return clearRedirectTimeout;
    }, [
        isPreview,
        isLoading,
        missingServiceSlug,
        mustAuthenticate,
        initialized,
        redirectToLogin,
        clearRedirectTimeout,
    ]);
    var autocompleteValues = useMemo(function () {
        if (!userInfo || !formData) {
            return {};
        }
        var values = {};
        if (Object.keys(formData).length > 0) {
            formData.pages.forEach(function (page) {
                flattenPageElements(page.elements).forEach(function (element) {
                    var elementValueKey = getElementValueKey(element);
                    var elementAutocomplete = element.autocomplete || "";
                    var elementType = element.type || "";
                    if (elementAutocomplete &&
                        elementType === SurveyElementTypeEnum.TEXT &&
                        elementAutocomplete in userInfo) {
                        values[elementValueKey] =
                            userInfo[elementAutocomplete];
                    }
                });
            });
        }
        return values;
    }, [userInfo, formData]);
    var autocompleteValuesKey = useMemo(function () { return JSON.stringify(autocompleteValues); }, [autocompleteValues]);
    var initialValues = useMemo(function () { return autocompleteValues; }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [autocompleteValuesKey]);
    var handleSubmit = useCallback(function (data, navigateUrl) { return __awaiter(void 0, void 0, void 0, function () {
        var userId, submittedAt, storeData, dbPromise, includeUserAuth, apiPromise, promises, results, dbResult, dbSuccess, status;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    userId = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username) || (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name);
                    submittedAt = new Date().toISOString();
                    storeData = {
                        userId: userId,
                        serviceSlug: serviceSlug,
                        answers: data,
                    };
                    dbPromise = config.storeResponse(formAttributes.id, storeData, accessTokenRef.current);
                    includeUserAuth = !!formAttributes.callbackIncludeUserAuth;
                    apiPromise = formAttributes.callbackURL
                        ? sendFormResponseToExternalAPI(formAttributes.callbackURL, __assign({ formName: formAttributes.title, serviceSlug: serviceSlug, submittedAt: submittedAt, answers: data }, (includeUserAuth ? { userId: userId } : {})), includeUserAuth ? accessTokenRef.current : undefined)
                        : null;
                    promises = apiPromise ? [dbPromise, apiPromise] : [dbPromise];
                    return [4 /*yield*/, Promise.allSettled(promises)];
                case 1:
                    results = _c.sent();
                    dbResult = results[0];
                    dbSuccess = dbResult.status === "fulfilled";
                    if (dbSuccess) {
                        setModalData({
                            open: true,
                            title: "Resposta enviada!",
                            message: "Formulário foi respondido com sucesso.",
                            variant: "success",
                            onClose: navigateUrl
                                ? function () {
                                    window.location.href = navigateUrl;
                                }
                                : redirectToPortal,
                        });
                    }
                    else {
                        console.error("".concat(logPrefix, "241 - Erro ao salvar resposta:"), dbResult);
                        status = (_b = (_a = dbResult.reason) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.status;
                        setModalData(__assign(__assign({ open: true }, getSubmitErrorFeedback(status)), { variant: "error" }));
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [
        userInfo,
        serviceSlug,
        formAttributes,
        accessTokenRef,
        config,
        logPrefix,
        redirectToPortal,
    ]);
    var handleCloseModal = useCallback(function (callback) {
        callback === null || callback === void 0 ? void 0 : callback();
        setModalData(function (prev) { return (__assign(__assign({}, prev), { open: false })); });
    }, []);
    var handleModalExited = useCallback(function () {
        setModalData({
            open: false,
            title: "",
            message: "",
            variant: "success",
            onClose: undefined,
        });
    }, []);
    if (isLoading) {
        return _jsx(Loading, {});
    }
    if (formNotFoundError) {
        return (_jsx(AlertContainer, { message: "Formul\u00E1rio n\u00E3o encontrado. Verifique se o link est\u00E1 correto.", severity: "info" }));
    }
    if (!isPreview) {
        if (missingServiceSlug) {
            return (_jsx(AlertContainer, { message: "O par\u00E2metro serviceSlug \u00E9 obrigat\u00F3rio na URL para enviar a resposta deste formul\u00E1rio. Verifique se o link est\u00E1 completo.", severity: "info" }));
        }
        if (mustAuthenticate) {
            // portal já respondeu: o login() sai neste ciclo e o alerta só piscaria
            return initialized ? (_jsx(Loading, {})) : (_jsx(AlertContainer, { message: "Este formul\u00E1rio exige autentica\u00E7\u00E3o. Redirecionando para o login\u2026", severity: "info" }));
        }
        if (!formAttributes.published) {
            return (_jsx(AlertContainer, { message: "Este formul\u00E1rio n\u00E3o est\u00E1 dispon\u00EDvel para envio no momento. Por favor, tente novamente mais tarde ou entre em contato com o atendimento respons\u00E1vel para mais informa\u00E7\u00F5es.", severity: "info" }));
        }
    }
    return (_jsxs(Box, __assign({ sx: { marginTop: "-10px" } }, { children: [Object.keys(formData).length > 0 && (_jsx(Grid, __assign({ container: true }, { children: _jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsx(FormRenderer, { formData: formData, onSubmit: handleSubmit, isPreview: isPreview, initialValues: initialValues }) })) }))), _jsxs(Dialog, __assign({ open: modalData.open, onClose: function () { return handleCloseModal(modalData.onClose); }, TransitionProps: { onExited: handleModalExited }, maxWidth: "sm", fullWidth: true }, { children: [_jsx(IconButton, __assign({ "aria-label": "Fechar", onClick: function () { return handleCloseModal(modalData.onClose); }, sx: {
                            position: "absolute",
                            right: 8,
                            top: 8,
                            zIndex: 1,
                            color: function (theme) { return theme.palette.grey[600]; },
                        } }, { children: _jsx(Close, {}) })), _jsx(DialogTitle, __assign({ sx: function (theme) { return ({
                            pt: 3,
                            pb: 2.5,
                            px: 3,
                            pr: 6,
                            bgcolor: modalData.variant === "error"
                                ? alpha(theme.palette.error.main, 0.08)
                                : alpha(theme.palette.success.main, 0.1),
                        }); } }, { children: _jsxs(Stack, __assign({ direction: "row", spacing: 2, alignItems: "center" }, { children: [modalData.variant === "error" ? (_jsx(ErrorOutline, { sx: {
                                        fontSize: 44,
                                        color: "error.main",
                                        flexShrink: 0,
                                    } })) : (_jsx(CheckCircle, { sx: {
                                        fontSize: 44,
                                        color: "success.main",
                                        flexShrink: 0,
                                    } })), _jsx(Typography, __assign({ variant: "h5", component: "span", sx: {
                                        fontWeight: 600,
                                    } }, { children: modalData.title }))] })) })), _jsx(DialogContent, __assign({ sx: { p: "24px !important" } }, { children: _jsx(DialogContentText, __assign({ component: "p", variant: "body1", sx: {
                                color: "text.secondary",
                            } }, { children: modalData.message })) }))] }))] })));
};
export default RenderContainer;
